<ng-container *ngIf="fields?.fieldType === 'tableRow'">
  <div class="table-container border-l border-r last:border-b-0 rounded-lg">
    <div class="table-body">
      <div
        *ngFor="let item of fieldsData"
        class="table-row hover:bg-secondary-active"
      >
        <div class="col col-domain">
          <ng-container *ngIf="item.domain?.length > 10; else shortDomain">
            {{ item.domain.slice(0, 7) }}<br />{{ item.domain.slice(7) }}
          </ng-container>
          <ng-template #shortDomain>{{ item.domain }}</ng-template>
        </div>

        <div class="col col-email">
          <span [innerHTML]="formatEmailProvider(item.EmailProvider)"></span>
        </div>

        <div
          class="col col-icon"
          [innerHTML]="item.SPF?.icon || item.SPF || '-'"
        ></div>

        <div
          class="col col-icon"
          [innerHTML]="item.DMARC?.icon || item.DMARC || '-'"
        ></div>
        <!-- <div
          class="col col-icon"
          [innerHTML]="item.DKIM?.icon || item.DKIM || '-'"
        ></div> -->
        <div
          class="col col-icon"
          [innerHTML]="item.WAF?.icon || item.WAF || '-'"
        ></div>
        <div class="col col-icon" [innerHTML]="item.SSL?.icon || '-'"></div>
        <div
          class="col col-icon"
          [innerHTML]="item.SECURITY?.icon || '-'"
        ></div>
        <div class="col col-icon" [innerHTML]="item.ROBOT?.icon || '-'"></div>
      </div>
    </div>
  </div>
</ng-container>
